import { render, staticRenderFns } from "./navigation-tabs.vue?vue&type=template&id=aed3e9f0&scoped=true&"
import script from "./navigation-tabs.vue?vue&type=script&lang=js&"
export * from "./navigation-tabs.vue?vue&type=script&lang=js&"
import style0 from "./navigation-tabs.vue?vue&type=style&index=0&id=aed3e9f0&prod&lang=scss&scoped=true&"
import style1 from "./navigation-tabs.vue?vue&type=style&index=1&id=aed3e9f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed3e9f0",
  null
  
)

export default component.exports